import type { NonNullRef } from '@lemonade-hq/cdk';
import type { UniclientAction } from '@lemonade-hq/uniclient-chat';
import { useContextMenuContext } from '@lemonade-hq/uniclient-theme';
import { useCallback, useRef } from 'react';
import { WizardContextMenu } from '../elements/WizardContextMenu';

interface UseWizardContextMenu {
  readonly openContextMenu: (items: UniclientAction[]) => void;
  readonly closeContextMenu: () => void;
}

export interface UseWizardContextMenuProps {
  readonly onActionRef: NonNullRef<(action?: UniclientAction) => Promise<unknown>>;
}

export function useWizardContextMenu({ onActionRef }: UseWizardContextMenuProps): UseWizardContextMenu {
  const { open: openMenu, close: closeContextMenu } = useContextMenuContext();
  const hasSubmittedRef = useRef(false);

  const performItemAction = useCallback(
    async (action?: UniclientAction) => {
      await onActionRef.current(action);
      closeContextMenu();
    },
    [onActionRef, closeContextMenu],
  );

  const openContextMenu = useCallback(
    (items: UniclientAction[]) => {
      hasSubmittedRef.current = false;

      openMenu({
        component: WizardContextMenu,
        props: {
          items,
          performAction: performItemAction,
        },
      });
    },
    [openMenu, performItemAction],
  );

  return {
    openContextMenu,
    closeContextMenu,
  };
}
